<style lang="scss" scoped src="./index.scss"></style>
<template>
  <div class="app-footer">
    <div class="app-footer__main">
      <div class="main-link">
        <div class="main-link__left" :style="{ width: layoutWidth }">
          <p class="title" v-t="'link.quick'"></p>
          <ul class="link-box">
            <li class="link-box__item" :class="{ 'link-box__item-en': currentLang === 'en' }" :key="item.name"
              v-for="item in link">
              <el-tooltip class="item" effect="dark" :content="item.name" placement="top-start">
                <a href="javascript:;" @click="goTo(item)">{{ item.name }}</a>
              </el-tooltip>
            </li>
          </ul>
        </div>
        <!-- <div class="main-link__right">
                    <div class="img">
                        <img src="./images/QR.png">
                    </div>
                    <div class="appName" v-t="'link.oaAPP'"></div>
                </div> -->
      </div>
      <div class="main-copy app-flex app-flex-r app-flex-o">
        <!-- <i class="iconfont icon-geely_svg"></i> -->
        <i class="geelyIcon geely-iconlogo"></i>
        <span class="main-copy__title">
          © {{ (new Date()).getFullYear() }} {{ $t('link.copyright') }}
          <a class="icp" href="https://beian.miit.gov.cn" target="_blank">{{ $t('link.icp') }}</a>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'appFooter',
  computed: {
    currentLang() {
      return this.$store.state.language
    },
    layoutWidth() {
      return this.$store.state.global.layoutWidth + 'px'
    },
    link() {
      return [{
        name: this.$t('link.purchasing'),
        url: 'https://oa.geely.com/purchasing'
      }, {
        name: this.$t('link.institute'),
        url: 'https://oa.geely.com/rd/SitePages/default.aspx'
      }, {
        name: this.$t('link.power'),
        url: 'https://oa.geely.com/drd/SitePages/default.aspx'
      }, {
        name: this.$t('link.commercial'),
        url: 'https://oa.geely.com/sites/gcv/SitePages/default.aspx'
      }, {
        name: this.$t('link.sichuan'),
        url: 'https://oa.geely.com/scsyc'
      }, {
        name: this.$t('link.international'),
        url: 'https://oa.geely.com/gic'
      }, {
        name: this.$t('link.information'),
        url: 'https://oa.geely.com/it/'
      },
      // {
      //   name: this.$t('link.personnel'),
      //   url: 'https://oa.geely.com/hr/'
      // },
      // {
      //   name: this.$t('link.ehr'),
      //   // url: 'http://10.86.86.37:8000/psp/HR91PRD/EMPLOYEE/HRMS/?cmd=start'
      //   url: 'http://psapp.geely.com/'
      // },
      {
        name: this.$t('link.geelyMall'),
        url: 'https://mall.geely.com/'
      }]
    }
  },
  methods: {
    goTo(item) {
      window.open(item.url)
    }
  }
}

</script>
